import { locales, type Locale } from './config'

/** Replace or prepend the locale segment while keeping the rest of the path. */
export function localizePathname(pathname: string, locale: Locale): string {
  const segments = pathname.split('/').filter(Boolean)
  if (segments.length > 0 && locales.includes(segments[0] as Locale)) {
    segments[0] = locale
  } else {
    segments.unshift(locale)
  }
  return `/${segments.join('/')}`
}
